// extracted by mini-css-extract-plugin
export default {"wordmark":"Wordmark_wordmark__Ajk5Y","my":"Wordmark_my__S6CYz","txt":"Wordmark_txt__I8v1G"};